import { Routes, Route, Navigate } from 'react-router-dom'
import { LanguageProvider } from './contexts/LanguageContext'
import { AuthProvider } from './contexts/AuthContext'
import Layout from './components/Layout'
import ProtectedRoute from './components/ProtectedRoute'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Vehicles from './pages/Vehicles'
import VehicleForm from './pages/VehicleForm'
import Brands from './pages/Brands'
import BrandForm from './pages/BrandForm'
import Models from './pages/Models'
import ModelForm from './pages/ModelForm'
import FuelTypes from './pages/FuelTypes'
import Colors from './pages/Colors'
import Transmissions from './pages/Transmissions'
import BodyTypes from './pages/BodyTypes'
import DeliveryStatuses from './pages/DeliveryStatuses'
import SaleStatuses from './pages/SaleStatuses'
import Options from './pages/Options'
import WarrantyTypes from './pages/WarrantyTypes'
import VehicleTypes from './pages/VehicleTypes'
import Trims from './pages/Trims'
import SeoTexts from './pages/SeoTexts'
import ChangePassword from './pages/ChangePassword'
import Statistics from './pages/Statistics'

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <Routes>
          {/* Public route */}
          <Route path="/login" element={<Login />} />
          
          {/* Protected routes */}
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Layout>
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    
                    {/* Vehicles */}
                    <Route path="/vehicles" element={<Vehicles />} />
                    <Route path="/vehicles/new" element={<VehicleForm />} />
                    <Route path="/vehicles/:id/edit" element={<VehicleForm />} />
                    
                    {/* Brands */}
                    <Route path="/brands" element={<Brands />} />
                    <Route path="/brands/new" element={<BrandForm />} />
                    <Route path="/brands/:id/edit" element={<BrandForm />} />
                    
                    {/* Models */}
                    <Route path="/models" element={<Models />} />
                    <Route path="/models/new" element={<ModelForm />} />
                    <Route path="/models/:id/edit" element={<ModelForm />} />
                    
                    {/* Filter Enums */}
                    <Route path="/fuel-types" element={<FuelTypes />} />
                    <Route path="/colors" element={<Colors />} />
                    <Route path="/transmissions" element={<Transmissions />} />
                    <Route path="/body-types" element={<BodyTypes />} />
                    <Route path="/delivery-statuses" element={<DeliveryStatuses />} />
                    <Route path="/sale-statuses" element={<SaleStatuses />} />
                    <Route path="/options" element={<Options />} />
                    <Route path="/warranty-types" element={<WarrantyTypes />} />
                    <Route path="/vehicle-types" element={<VehicleTypes />} />
                    <Route path="/trims" element={<Trims />} />
                    
                    {/* SEO */}
                    <Route path="/seo-texts" element={<SeoTexts />} />
                    
                    {/* Statistics */}
                    <Route path="/statistics" element={<Statistics />} />
                    
                    {/* Auth */}
                    <Route path="/change-password" element={<ChangePassword />} />
                    
                    {/* Catch all - redirect to dashboard */}
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </LanguageProvider>
  )
}

export default App
